// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2j-1";
export var rateTableServiceLevelDropdown = "_2j-3";
export var rateTableTypeDropdown = "_2j-0";
export var rateTableValueModeDropdown = "_2j-2";